import { Box, IconButton, MenuItem, Select, Typography } from "@mui/material";
import {
  FirstPage,
  LastPage,
  KeyboardArrowLeft,
  KeyboardArrowRight,
} from "@mui/icons-material";

interface Props {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => void;
  onChangeLinhasPorPagina?: (newPageSize: number) => void;
  pageSizeOptions?: number[];
}

function CustomPaginationActions(props: Props) {
  const {
    count,
    page,
    rowsPerPage,
    onPageChange,
    onChangeLinhasPorPagina,
    pageSizeOptions = [5, 10],
  } = props;

  const totalPages = Math.ceil(count / rowsPerPage);

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      width="100%"
      px={2}
      py={1}
    >
      <Box display="flex" alignItems="center">
        {onChangeLinhasPorPagina && pageSizeOptions?.length > 0 && (
          <>
            <Typography variant="body2">Linhas por página:</Typography>
            <Select
              value={rowsPerPage}
              onChange={(e) =>
                onChangeLinhasPorPagina?.(
                  parseInt(e.target.value as string, 10)
                )
              }
              variant="outlined"
              size="small"
              sx={{ width: 80, marginLeft: 1 }}
            >
              {pageSizeOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </>
        )}
      </Box>
      <Box display="flex" alignItems="center">
        <Typography variant="body2" sx={{ marginRight: 1 }}>
          {page * rowsPerPage + 1}–{Math.min((page + 1) * rowsPerPage, count)}{" "}
          de {count}
        </Typography>

        <IconButton onClick={(e) => onPageChange(e, 0)} disabled={page === 0}>
          <FirstPage />
        </IconButton>
        <IconButton
          onClick={(e) => onPageChange(e, page - 1)}
          disabled={page === 0}
        >
          <KeyboardArrowLeft />
        </IconButton>
        <IconButton
          onClick={(e) => onPageChange(e, page + 1)}
          disabled={page >= totalPages - 1}
        >
          <KeyboardArrowRight />
        </IconButton>
        <IconButton
          onClick={(e) => onPageChange(e, totalPages - 1)}
          disabled={page >= totalPages - 1}
        >
          <LastPage />
        </IconButton>
      </Box>
    </Box>
  );
}

export default CustomPaginationActions;
